import { NgModule } from '@angular/core';

// TODO:Spartacus - // TODO:Spartacus - Variable translations has been removed and is no longer part of the public API. 
import { translationChunksConfig, translationsEn } from "@spartacus/assets";

import { FeaturesConfig, I18nConfig, I18nModule, OccConfig, provideConfig, SiteContextConfig,PageMetaConfig,AuthConfig } from "@spartacus/core";

import { defaultB2bOccConfig } from "@spartacus/setup";

import { defaultCmsContentProviders, layoutConfig, mediaConfig } from "@spartacus/storefront";

import { translationOverwrites } from '../translations/en/custom_asm';

export const asmFeatureConfig = {

  features: { asm: true },

};
@NgModule({
  declarations: [],
  imports: [I18nModule
  ],
  providers: [provideConfig(layoutConfig), provideConfig(mediaConfig), ...defaultCmsContentProviders, provideConfig(<OccConfig>{
  
    context: {
      currency:['USD'],
      language: ['en'],
    },
  }), provideConfig({
    i18n: {
      backend: {
        loadPath: 'assets/i18n-assets/{{lng}}/{{ns}}.json'
      },
      resources: {
        en: translationsEn
      },
      chunks: {
        ...translationChunksConfig,
        logoutpage:['statictext','helpnfaq'],
        dashboardPage: ['dashboard','invoice','credit','orders'],
        joinAccountPage: ['breadcrumb','form'],
        customAsm: ['asm'],
        startOrderPage: ['startOrder','memebership','creditBlockUk','startorderUk'],
        orgLocation:['orgLocation','orgLocform'],
        registration:['progresslabel','bussinessDetails','formLevel','billinginfo','payinginfo','Shippinglocations','reviewpage','registrataionbreadcrumbs','registrationnhstxt'],
        financialDashboard:['financialDashboard'],
        myMaterialsOrdersPage:['myMaterial'],
        materialpageUk:['MaterialUk','materialprebook'],
        myprofile:['profile','accountinfo','membership','consent','location','autorollover','ukprofile','permission'],
        Myorders:['cancelOrder','editorder','myorder','ukmyorder'],
        paymentInfoPage:['paymentinfo','errormessage'],
        schedulePayment:['schedulepay'],
        returnsUS:['returns'],
        allInvoicePage:['allinvoice','iframesection'],
        contactusPage:['contactform'],
        orderSummary:['ordersummary','ukordersummary'],
        returnspageUK:['returnsUK'],
        prebookform:['prebookform']
      },
      fallbackLang: 'en',
    }
  }), provideConfig(<FeaturesConfig>{
    features: {
       level: '221121.10.0'
    }
  }), provideConfig(asmFeatureConfig), provideConfig(defaultB2bOccConfig),
  provideConfig(<PageMetaConfig>{
    pageMeta:{
      resolvers:[
        {property: 'title' , method: 'resolveTitle', },
        {property: 'heading' , method: 'resolveHeading', },
        {property: 'breadCrumbs' , method: 'resolveBreadCrumbs', },
        {property: 'description' , method: 'resolveDescription', disabledInCsr: false, },
        {property: 'image' , method: 'resolveImage', disabledInCsr: true, },
        {property: 'robots' , method: 'resolveRobots', disabledInCsr: false, },
        {property: 'canonicalUrl' , method: 'resolveCanonicalUrl', disabledInCsr: false, },
 
      ]
    }
  }),
  provideConfig({
    i18n: {
      resources: translationOverwrites
    },
  })]
})
export class SpartacusConfigurationModule { }